(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4749],{

/***/ 88896:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/international",
      function () {
        return __webpack_require__(64031);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$$default": function() { return /* binding */ $$default; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ $$default; },
  "make": function() { return /* binding */ international_bs_make; }
});

// EXTERNAL MODULE: ./src/bindings/Fresnel.bs.js
var Fresnel_bs = __webpack_require__(7545);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
;// CONCATENATED MODULE: ./src/components/pages/international/InternationalHeader.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function InternationalHeader(props) {
    return jsx_runtime.jsx("h1", {
        children: util_bs/* ReactStuff.s */.p_.s("Buying eGift cards for someone overseas?"),
        className: "text-left xs:text-center text-3xl md:text-4xl font-bold mt-10 md:mt-20"
    });
}
var make = InternationalHeader;
 /* Util Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/list.js
var list = __webpack_require__(62494);
// EXTERNAL MODULE: ./src/components/library/Button.bs.js
var Button_bs = __webpack_require__(59037);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_obj.js
var caml_obj = __webpack_require__(84445);
// EXTERNAL MODULE: ./src/components/CmsImage.bs.js
var CmsImage_bs = __webpack_require__(34442);
;// CONCATENATED MODULE: ./src/components/pages/international/InternationalContentMobile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var prodDomains = {
    hd: [
        "au",
        "https://www.prezzee.com.au"
    ],
    tl: {
        hd: [
            "ca",
            "https://www.prezzee.ca"
        ],
        tl: {
            hd: [
                "us",
                "https://www.prezzee.com"
            ],
            tl: {
                hd: [
                    "uk",
                    "https://www.prezzee.uk"
                ],
                tl: {
                    hd: [
                        "nz",
                        "https://www.prezzee.co.nz"
                    ],
                    tl: /* [] */ 0
                }
            }
        }
    }
};
var stgDomains = {
    hd: [
        "au",
        "https://stg.prezzee.com.au"
    ],
    tl: {
        hd: [
            "ca",
            "https://stg.prezzee.ca"
        ],
        tl: {
            hd: [
                "us",
                "https://stg.prezzee.com"
            ],
            tl: {
                hd: [
                    "uk",
                    "https://stg.prezzee.uk"
                ],
                tl: {
                    hd: [
                        "nz",
                        "https://stg.prezzee.co.nz"
                    ],
                    tl: /* [] */ 0
                }
            }
        }
    }
};
var isStg = "https://www.prezzee.com/".includes("stg");
function InternationalContentMobile(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                    src: "/images/international/map_with_no_arrows.svg",
                    alt: "Prezzee International map",
                    width: 737,
                    height: 404,
                    className: "w-11/12 sm:w-9/12 mx-auto",
                    sizes: "(max-width: 640px) 82vw, 72vw"
                }),
                className: "my-16"
            }),
            caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                TAG: /* Ok */ 0,
                _0: /* Australia */ 0
            }) || caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                TAG: /* Ok */ 0,
                _0: /* NewZealand */ 3
            }) ? jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("Introducing USA GIft Cards, now available on Prezzee! Send family and friends back home their favourite gift cards from top USA brands including Macy's, JC Penny and more.")
                            }),
                            jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Buy USA gift cards"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "h-12 w-56 mt-6"
                                    ])
                                }),
                                href: isStg ? list/* assoc */.yG("us", stgDomains) : list/* assoc */.yG("us", prodDomains),
                                target: "_blank"
                            })
                        ],
                        className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                    }),
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("We're finally in Canada! Shop our ever expanding range of digital gift cards from leading Canadian brands such as Uber and Doordash.")
                            }),
                            jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Buy CA gift cards"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "h-12 w-56 mt-6"
                                    ])
                                }),
                                href: isStg ? list/* assoc */.yG("ca", stgDomains) : list/* assoc */.yG("ca", prodDomains),
                                target: "_blank"
                            })
                        ],
                        className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                    }),
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("Make sending eGifts to the UK a breeze with Prezzee. Choose from top UK brands including John Lewis, Marks & Spencers and Debenhams. What could be easier!")
                            }),
                            jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Buy UK gift cards"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "h-12 w-56 mt-6"
                                    ])
                                }),
                                href: isStg ? list/* assoc */.yG("uk", stgDomains) : list/* assoc */.yG("uk", prodDomains),
                                target: "_blank"
                            })
                        ],
                        className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                    }),
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("Check out the ever expanding range of eGift cards from hundreds of top brands, for everyone at home down under. Everything you need at your fingertips.")
                            }),
                            jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Buy Aussie gift cards"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "h-12 w-56 mt-6"
                                    ])
                                }),
                                href: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                    TAG: /* Ok */ 0,
                                    _0: /* Australia */ 0
                                }) ? "/store/" : isStg ? list/* assoc */.yG("au", stgDomains) : list/* assoc */.yG("au", prodDomains),
                                target: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                    TAG: /* Ok */ 0,
                                    _0: /* Australia */ 0
                                }) ? "_self" : "_blank"
                            })
                        ],
                        className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                    }),
                    caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                        TAG: /* Ok */ 0,
                        _0: /* Australia */ 0
                    }) ? jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("Forget pigeon post across the Tasman, make Prezzee your one stop shop for sending eGift Cards to New Zealand. Favourite brands include Farmers, David Jones, JB HiFi and more.")
                            }),
                            jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Buy NZ gift cards"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "h-12 w-56 mt-6"
                                    ])
                                }),
                                href: isStg ? list/* assoc */.yG("nz", stgDomains) : list/* assoc */.yG("nz", prodDomains),
                                target: "_blank"
                            })
                        ],
                        className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                    }) : jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("Make Prezzee your one stop shop for local New Zealand gift cards. Favourite brands include Farmers, David Jones, JB HiFi and more.")
                            }),
                            jsx_runtime.jsx("a", {
                                children: jsx_runtime.jsx("button", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Buy NZ gift cards"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "h-12 w-56 mt-6"
                                    ])
                                }),
                                href: "/store/"
                            })
                        ],
                        className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                    })
                ]
            }) : jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("a", {
                        children: jsx_runtime.jsx("button", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy USA gift cards"),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "h-12 w-56 mt-6 block"
                            ])
                        }),
                        href: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                            TAG: /* Ok */ 0,
                            _0: /* UnitedStates */ 2
                        }) ? "/store/" : isStg ? list/* assoc */.yG("us", stgDomains) : list/* assoc */.yG("us", prodDomains),
                        target: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                            TAG: /* Ok */ 0,
                            _0: /* UnitedStates */ 2
                        }) ? "_self" : "_blank"
                    }),
                    jsx_runtime.jsx("a", {
                        children: jsx_runtime.jsx("button", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy CA gift cards"),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "h-12 w-56 mt-6 block"
                            ])
                        }),
                        href: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                            TAG: /* Ok */ 0,
                            _0: /* Canada */ 4
                        }) ? "/store/" : isStg ? list/* assoc */.yG("ca", stgDomains) : list/* assoc */.yG("ca", prodDomains),
                        target: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                            TAG: /* Ok */ 0,
                            _0: /* Canada */ 4
                        }) ? "_self" : "_blank"
                    }),
                    jsx_runtime.jsx("a", {
                        children: jsx_runtime.jsx("button", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy UK gift cards"),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "h-12 w-56 mt-6 block"
                            ])
                        }),
                        href: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                            TAG: /* Ok */ 0,
                            _0: /* GreatBritain */ 1
                        }) ? "/store/" : isStg ? list/* assoc */.yG("uk", stgDomains) : list/* assoc */.yG("uk", prodDomains),
                        target: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                            TAG: /* Ok */ 0,
                            _0: /* GreatBritain */ 1
                        }) ? "_self" : "_blank"
                    }),
                    jsx_runtime.jsx("a", {
                        children: jsx_runtime.jsx("button", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy Aussie gift cards"),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "h-12 w-56 mt-6 block"
                            ])
                        }),
                        href: isStg ? list/* assoc */.yG("au", stgDomains) : list/* assoc */.yG("au", prodDomains),
                        target: "_blank"
                    }),
                    jsx_runtime.jsx("a", {
                        children: jsx_runtime.jsx("button", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy NZ gift cards"),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "h-12 w-56 mt-6 block"
                            ])
                        }),
                        href: isStg ? list/* assoc */.yG("nz", stgDomains) : list/* assoc */.yG("nz", prodDomains),
                        target: "_blank"
                    })
                ],
                className: "my-10 flex flex-wrap justify-between"
            })
        ]
    });
}
var Link;
var InternationalContentMobile_bs_make = InternationalContentMobile;
 /* isStg Not a pure module */ 

// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
;// CONCATENATED MODULE: ./src/components/pages/international/InternationalContentDesktop.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var InternationalContentDesktop_bs_image = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.px(1205)),
    tl: /* [] */ 0
});
var Styles = {
    image: InternationalContentDesktop_bs_image
};
var InternationalContentDesktop_bs_prodDomains = {
    hd: [
        "au",
        "https://www.prezzee.com.au"
    ],
    tl: {
        hd: [
            "ca",
            "https://www.prezzee.ca"
        ],
        tl: {
            hd: [
                "us",
                "https://www.prezzee.com"
            ],
            tl: {
                hd: [
                    "uk",
                    "https://www.prezzee.uk"
                ],
                tl: {
                    hd: [
                        "nz",
                        "https://www.prezzee.co.nz"
                    ],
                    tl: /* [] */ 0
                }
            }
        }
    }
};
var InternationalContentDesktop_bs_stgDomains = {
    hd: [
        "au",
        "https://stg.prezzee.com.au"
    ],
    tl: {
        hd: [
            "ca",
            "https://stg.prezzee.ca"
        ],
        tl: {
            hd: [
                "us",
                "https://stg.prezzee.com"
            ],
            tl: {
                hd: [
                    "uk",
                    "https://stg.prezzee.uk"
                ],
                tl: {
                    hd: [
                        "nz",
                        "https://stg.prezzee.co.nz"
                    ],
                    tl: /* [] */ 0
                }
            }
        }
    }
};
var InternationalContentDesktop_bs_isStg = "https://www.prezzee.com/".includes("stg");
function InternationalContentDesktop(props) {
    if (caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
        TAG: /* Ok */ 0,
        _0: /* Australia */ 0
    }) || caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
        TAG: /* Ok */ 0,
        _0: /* NewZealand */ 3
    })) {
        return jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                    src: "/images/international/map_with_no_arrows.svg",
                    alt: "Prezzee International map",
                    width: 1205,
                    height: 660,
                    className: Cn_bs/* make */.S([
                        InternationalContentDesktop_bs_image,
                        "mx-auto max-w-full mt-12"
                    ]),
                    sizes: "(max-width: 1280px) 100vw, 1205px"
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsx("p", {
                                        children: util_bs/* ReactStuff.s */.p_.s("We're finally in Canada! Shop our ever expanding range of digital gift cards from leading Canadian brands such as Uber and Doordash."),
                                        className: "mb-6"
                                    }),
                                    jsx_runtime.jsx("a", {
                                        children: util_bs/* ReactStuff.s */.p_.s("Buy CA gift cards"),
                                        className: Cn_bs/* make */.S([
                                            Button_bs/* primaryStyle */.vP,
                                            "px-4 py-4"
                                        ]),
                                        href: InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("ca", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("ca", InternationalContentDesktop_bs_prodDomains),
                                        target: "_blank"
                                    })
                                ],
                                className: " w-20rem mr-60"
                            }),
                            jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsx("p", {
                                        children: util_bs/* ReactStuff.s */.p_.s("Make sending eGifts to the UK a breeze with Prezzee. Choose from top UK brands including John Lewis, Marks & Spencers and Debenhams. What could be easier!"),
                                        className: "mb-6"
                                    }),
                                    jsx_runtime.jsx("a", {
                                        children: util_bs/* ReactStuff.s */.p_.s("Buy UK gift cards"),
                                        className: Cn_bs/* make */.S([
                                            Button_bs/* primaryStyle */.vP,
                                            "px-4 py-4"
                                        ]),
                                        href: InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("uk", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("uk", InternationalContentDesktop_bs_prodDomains),
                                        target: "_blank"
                                    })
                                ],
                                className: " w-20rem mt-10"
                            })
                        ],
                        className: "flex justify-start  mb-4 gap-50"
                    }),
                    className: "absolute top-0 w-full"
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("Introducing USA Gift Cards, now available on Prezzee! Send family and friends back home their favourite gift cards from top USA brands including Macy's, JC Penny and more."),
                                className: "mb-6"
                            }),
                            jsx_runtime.jsx("a", {
                                children: util_bs/* ReactStuff.s */.p_.s("Buy USA gift cards"),
                                className: Cn_bs/* make */.S([
                                    Button_bs/* primaryStyle */.vP,
                                    "px-4 py-4"
                                ]),
                                href: InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("us", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("us", InternationalContentDesktop_bs_prodDomains),
                                target: "_blank"
                            })
                        ],
                        className: "w-14rem xl:w-18rem mb-24 xl:mb-40"
                    }),
                    className: "absolute bottom-0 w-full "
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("div", {
                                className: "w-4/12 xl:w-5/12"
                            }),
                            jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsx("p", {
                                        children: util_bs/* ReactStuff.s */.p_.s("Check out the ever expanding range of eGift cards from hundreds of top brands, for everyone at home down under. Everything you need at your fingertips."),
                                        className: "mb-6"
                                    }),
                                    jsx_runtime.jsx("a", {
                                        children: util_bs/* ReactStuff.s */.p_.s("Buy Aussie gift cards"),
                                        className: Cn_bs/* make */.S([
                                            Button_bs/* primaryStyle */.vP,
                                            "px-4 py-4"
                                        ]),
                                        href: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                            TAG: /* Ok */ 0,
                                            _0: /* Australia */ 0
                                        }) ? "/store/" : InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("au", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("au", InternationalContentDesktop_bs_prodDomains),
                                        target: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                            TAG: /* Ok */ 0,
                                            _0: /* Australia */ 0
                                        }) ? "_self" : "_blank"
                                    })
                                ],
                                className: "flex-none w-64 xl:w-20rem ml-16"
                            })
                        ],
                        className: "flex"
                    }),
                    className: "absolute bottom-0 w-full"
                }),
                caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                    TAG: /* Ok */ 0,
                    _0: /* Australia */ 0
                }) ? jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s("Forget pigeon post across the Tasman, make Prezzee your one stop shop for sending eGift Cards to New Zealand. Favourite brands include Farmers, David Jones, JB HiFi and more."),
                            className: "mb-6"
                        }),
                        jsx_runtime.jsx("a", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy NZ gift cards"),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "px-4 py-4"
                            ]),
                            href: InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("nz", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("nz", InternationalContentDesktop_bs_prodDomains),
                            target: "_blank"
                        })
                    ],
                    className: "absolute bottom-0 right-0 w-48 md:w-20rem -mb-24"
                }) : jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s("Make Prezzee your one stop shop for local New Zealand gift cards. Favourite brands include Farmers, David Jones, JB HiFi and more."),
                            className: "mb-6"
                        }),
                        jsx_runtime.jsx("a", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy NZ gift cards"),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "px-4 py-4"
                            ]),
                            href: "/store/"
                        })
                    ],
                    className: "absolute bottom-0 right-0 w-48 md:w-20rem -mb-24"
                })
            ],
            className: "relative mt-10 pt-32 px-5 md:pb-24 md:mb-40"
        });
    } else {
        return jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                    src: "/images/international/map_with_no_arrows.svg",
                    alt: "Prezzee International map",
                    width: 1205,
                    height: 660,
                    className: Cn_bs/* make */.S([
                        InternationalContentDesktop_bs_image,
                        "mx-auto max-w-full"
                    ])
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("div", {
                                className: "w-5/12"
                            }),
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx("a", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Buy UK gift cards"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "px-4 py-4"
                                    ]),
                                    href: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                        TAG: /* Ok */ 0,
                                        _0: /* GreatBritain */ 1
                                    }) ? "/store/" : InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("uk", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("uk", InternationalContentDesktop_bs_prodDomains),
                                    target: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                        TAG: /* Ok */ 0,
                                        _0: /* GreatBritain */ 1
                                    }) ? "_self" : "_blank"
                                }),
                                className: "flex-none ml-10"
                            })
                        ],
                        className: "flex mb-4"
                    }),
                    className: "absolute top-0 w-full"
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsx("div", {
                            children: jsx_runtime.jsx("a", {
                                children: util_bs/* ReactStuff.s */.p_.s("Buy CA gift cards"),
                                className: Cn_bs/* make */.S([
                                    Button_bs/* primaryStyle */.vP,
                                    "px-4 py-4"
                                ]),
                                href: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                    TAG: /* Ok */ 0,
                                    _0: /* Canada */ 4
                                }) ? "/store/" : InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("ca", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("ca", InternationalContentDesktop_bs_prodDomains),
                                target: "_blank"
                            }),
                            className: "flex-none w-20rem ml-10"
                        }),
                        className: "flex mb-4"
                    }),
                    className: "absolute top-0"
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsx("a", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy USA gift cards"),
                            className: Cn_bs/* make */.S([
                                Button_bs/* primaryStyle */.vP,
                                "px-4 py-4"
                            ]),
                            href: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                TAG: /* Ok */ 0,
                                _0: /* UnitedStates */ 2
                            }) ? "/store/" : InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("us", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("us", InternationalContentDesktop_bs_prodDomains),
                            target: caml_obj/* equal */.Dg(util_bs/* EnvUtil.currentCountry */.i3.currentCountry, {
                                TAG: /* Ok */ 0,
                                _0: /* UnitedStates */ 2
                            }) ? "_self" : "_blank"
                        }),
                        className: "mb-40 xl:mb-48"
                    }),
                    className: "absolute bottom-0 w-full"
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("div", {
                                className: "w-5/12 xl:w-6/12"
                            }),
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx("a", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Buy Aussie gift cards"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "px-4 py-4"
                                    ]),
                                    href: InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("au", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("au", InternationalContentDesktop_bs_prodDomains),
                                    target: "_blank"
                                }),
                                className: "flex-none ml-16 mb-10"
                            })
                        ],
                        className: "flex"
                    }),
                    className: "absolute bottom-0 w-full"
                }),
                jsx_runtime.jsx("div", {
                    children: jsx_runtime.jsx("a", {
                        children: util_bs/* ReactStuff.s */.p_.s("Buy NZ gift cards"),
                        className: Cn_bs/* make */.S([
                            Button_bs/* primaryStyle */.vP,
                            "px-4 py-4"
                        ]),
                        href: InternationalContentDesktop_bs_isStg ? list/* assoc */.yG("nz", InternationalContentDesktop_bs_stgDomains) : list/* assoc */.yG("nz", InternationalContentDesktop_bs_prodDomains),
                        target: "_blank"
                    }),
                    className: "absolute bottom-0 right-0 -mb-16"
                })
            ],
            className: "relative mt-20 px-5 md:mb-40"
        });
    }
}
var InternationalContentDesktop_bs_Link;
var InternationalContentDesktop_bs_make = InternationalContentDesktop;
 /* image Not a pure module */ 

;// CONCATENATED MODULE: ./src/pages/international.bs.js
__webpack_require__(14473);
// Generated by ReScript, PLEASE EDIT WITH CARE





function International(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(make, {}),
            jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                lessThan: "lg",
                children: jsx_runtime.jsx(InternationalContentMobile_bs_make, {})
            }),
            jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                greaterThanOrEqual: "lg",
                children: jsx_runtime.jsx(InternationalContentDesktop_bs_make, {})
            })
        ],
        className: "xl:container mx-auto px-5"
    });
}
var international_bs_make = International;
var $$default = International;
var __N_SSP = true;
 /* Fresnel Not a pure module */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(88896); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);